import { Box } from '@constellation/core';
import styled from 'styled-components';

export const StyledImage = styled('img')`
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-height: 180px;
`;

export const StyledBox = styled(Box)`
  flex: 1;
`;
